// extracted by mini-css-extract-plugin
module.exports = {"paymentDetails":"SettingsPaymentDetails_paymentDetails__KfBPl"};